import ProductCard from "~/components/ProductCard.jsx";

const ModalContent = ({ activeCollection }) => {
  // console.log("ModalContent activeCollection", activeCollection);

  const { collectionHandle, products, collectionSubtitle } = activeCollection;

  const formattedCollectionHandle = collectionHandle.replace(/-/g, " ");

  return (
    <div className="w-90 mx-auto md:w-3/4 px-6 py-12 md:p-12 h-[90vh] md:h-[60vh] overflow-y-auto no-scrollbar">
      <span className="text-3xl font-semibold mb-4 inline-block uppercase">
        {formattedCollectionHandle}
      </span>

      <span className="text-lg text-gray-500 mb-4 block uppercase">{collectionSubtitle}</span>

      <div className="flex flex-col md:grid md:grid-cols-2 gap-8 pt-4 border-t-2 border-solid border-[#d9d9d9]">
        {products.length > 0 ? (
          products.map((product) => (
            <ProductCard
              key={product.id}
              product={product}
              collectionHandle={collectionHandle}
              pdp={false}
            />
          ))
        ) : (
          <p>No products found</p>
        )}
      </div>
    </div>
  );
};

export default ModalContent;
